import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'icon-not-ok',
  templateUrl: './not-ok.component.svg',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotOkComponent {}
